export default class extends HTMLElement {
  connectedCallback () {
    this.id = `embed-snippet-${Math.random().toString(32).split('.')[1]}`

    this.type = this.dataset.visibleType || 'frontend_code'
    this.inputName = this.dataset.inputName || 'type'
    this.codeEl = this.querySelector(`code[data-type="${this.type}"]`)

    this.clipboardEl.dataset.text = this.codeEl.dataset.clipboardText

    this.querySelectorAll(`input[name="${this.inputName}"]`).forEach((el) => {
      el.addEventListener('change', this.onChange)
    })

    this.querySelectorAll(`select[name="${this.inputName}"]`).forEach((el) => {
      el.addEventListener('change', this.onChange)
    })
  }

  onChange = (e) => {
    this.querySelectorAll('pre').forEach((el) => el.classList.add('hidden'))

    this.type = e.target.value
    this.codeEl = this.querySelector(`code[data-type="${this.type}"]`)

    this.codeEl.parentElement.classList.remove('hidden')

    this.clipboardEl.dataset.text = this.codeEl.dataset.clipboardText
  }

  get clipboardEl () {
    return this.querySelector('clipboard-copy')
  }
}
